const SDK_VERSION = "10.62.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
